import * as React from 'react';

import './index.less';

export default function TitleBox(props: any) {
  const { title, more, jumpMore } = props;
  return (
    <div className='c-l-title'>
      <span className='l-t-left'>{title}</span>
      <span className='l-t-right' onClick={more ? jumpMore : null}>
        {more ? `${more} > ` : null}{' '}
      </span>
    </div>
  );
}
